import { jsx as _jsx } from "react/jsx-runtime";
import React, { useCallback, useRef, useState } from "react";
import { useAuth, useLanguage } from "@/app";
import { isWebPaymentEnv } from "@/shared/lib/paymentNavigation";
import { SubscriptionConsentModal } from "../ui/SubscriptionConsentModal/SubscriptionConsentModal";
/**
 * Согласие на автосписания перед оформлением подписки. Устроен как
 * `useBillingEmailGate`: `ensureConsent` возвращает промис, который решается
 * кликом в модалке, — так общий флоу покупки остаётся линейным.
 */
export function useSubscriptionConsent() {
    const { user } = useAuth();
    const { language } = useLanguage();
    const [pkg, setPkg] = useState(null);
    const resolverRef = useRef(null);
    const ensureConsent = useCallback((target) => {
        // Прошлый вопрос (если модалку переоткрыли) закрываем отказом.
        resolverRef.current?.({ ok: false });
        setPkg(target);
        return new Promise((resolve) => {
            resolverRef.current = resolve;
        });
    }, []);
    const settle = useCallback((result) => {
        setPkg(null);
        resolverRef.current?.(result);
        resolverRef.current = null;
    }, []);
    const hasBillingEmail = Boolean(user?.billing_email?.trim());
    const handleConfirm = useCallback(() => {
        // Вкладку оплаты открываем синхронно, ДО любого await — иначе браузер
        // заблокирует попап. Почты для чека нет → не открываем: сперва её спросит
        // модалка почты и откроет вкладку в своём сабмите (см. useBillingEmailGate).
        const payWindow = isWebPaymentEnv() && hasBillingEmail
            ? window.open("about:blank", "_blank")
            : null;
        settle({ ok: true, payWindow });
    }, [hasBillingEmail, settle]);
    const handleClose = useCallback(() => settle({ ok: false }), [settle]);
    const subscriptionConsentModal = (_jsx(SubscriptionConsentModal, { packageItem: pkg, language: language, onClose: handleClose, onConfirm: handleConfirm }));
    return { ensureConsent, subscriptionConsentModal };
}
